/* unplugin-vue-components disabled */import { render } from "./agent.vue?vue&type=template&id=a6f1c6f6&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"

import "./agent.vue?vue&type=style&index=0&id=a6f1c6f6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f1c6f6"],['__file',"src/controls/agent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6f1c6f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6f1c6f6', __exports__)) {
    api.reload('a6f1c6f6', __exports__)
  }
  
  module.hot.accept("./agent.vue?vue&type=template&id=a6f1c6f6&scoped=true", () => {
    api.rerender('a6f1c6f6', render)
  })

}


export default __exports__